import { NgModule } from '@angular/core';
import { LanguageHeaderComponent } from './language-header.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [LanguageHeaderComponent],
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatSelectModule, MatInputModule],
  exports: [LanguageHeaderComponent],
})
export class LanguageHeaderModule {}
